import { FormEvent, useState } from "react";
import { ArrowRight, Eye, EyeOff, LockKeyhole } from "lucide-react";
import { login } from "../api";
import type { AuthUser } from "../types";
import { BrandMark } from "./BrandMark";

export function Login({ onLogin }: { onLogin: (user: AuthUser) => void }) {
  const [email, setEmail] = useState("admin@arconte.mx");
  const [password, setPassword] = useState("13571113");
  const [show, setShow] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (event: FormEvent) => {
    event.preventDefault();
    setLoading(true);
    setError("");
    try {
      const result = await login(email, password);
      onLogin(result.user);
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : "No fue posible iniciar sesión");
    } finally {
      setLoading(false);
    }
  };

  const enterDemo = () =>
    onLogin({ id: "demo", email: "demo@arconte.mx", full_name: "Operador Demo", role: "operator" });

  return (
    <main className="login-shell">
      <div className="login-grid" aria-hidden="true" />
      <div className="login-aura" aria-hidden="true" />
      <section className="login-intro">
        <BrandMark />
        <div>
          <span className="eyebrow">CENTRO DE INTELIGENCIA LOGÍSTICA</span>
          <h1>Visibilidad total.<br /><i>Decisión inmediata.</i></h1>
          <p>Telemetría, video y diagnóstico predictivo de toda la flotilla desde una sola sala de control.</p>
        </div>
        <footer><span /> QUASARYX · INTELIGENCIA DE FLOTILLAS</footer>
      </section>
      <section className="login-card">
        <span className="login-card__line" />
        <LockKeyhole size={22} />
        <span className="eyebrow">ACCESO RESTRINGIDO</span>
        <h2>Consola C5</h2>
        <p>Ingrese sus credenciales de operación.</p>
        <form onSubmit={submit}>
          <label>
            CORREO INSTITUCIONAL
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
          </label>
          <label>
            CONTRASEÑA
            <div className="password-field">
              <input type={show ? "text" : "password"} value={password} onChange={(e) => setPassword(e.target.value)} />
              <button type="button" onClick={() => setShow(!show)} aria-label="Mostrar contraseña">
                {show ? <EyeOff size={16} /> : <Eye size={16} />}
              </button>
            </div>
          </label>
          {error && <span className="form-error">{error}</span>}
          <button className="primary-button" disabled={loading}>
            {loading ? "AUTENTICANDO..." : "INGRESAR AL CENTRO"} <ArrowRight size={16} />
          </button>
          <button className="demo-button" type="button" onClick={enterDemo}>Explorar con datos simulados</button>
        </form>
        <small>Acceso monitoreado y registrado en bitácora.</small>
      </section>
    </main>
  );
}
